<template>
  <div class="">
    <top-header :type="6" :hasBorder="true" :placeholder="compType==0 ? '经纪人' :'操作员'" :bgColor="'#fff'"
                fontSize="0.32rem"/>
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner m_flex_box flex_vc flex_jz" v-for="(item ,index) in list" :key="index"
               @click="toDetail('/agentDetail', {id:item.id,compType:compType})">
            <div class="left flex_vc m_flex_box">
              <img v-lazy="imgPath + 'sClf/' + item.brokerImg + '.jpg'" alt="">
              <div>
                <h5>{{item.brokerName ? item.brokerName : '-'}}</h5>
                <p>{{item.compName ? item.compName : '-'}}-{{item.storeName ? item.storeName : '-'}}</p>
              </div>
            </div>
            <div class="m_flex_box flex_jz right">
              <a @click.stop="callTo(item.phone, 1, item.id)">
                <img src="@/assets/img/r_tel.png" alt="">
              </a>
              <img src="@/assets/img/r_chat.png" alt="">
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  data() {
    return {
      isLoading: false,
      listPage: 1,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      area: this.$route.query.area,
      compId: this.$route.query.compId,
      storeId: this.$route.query.storeId,
      compType: this.$route.query.compType
    };
  },
  components: {
    topHeader,
  },
  mounted() {

  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    onRefresh() {
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/broker/permit/getBrokerList.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            compType: this.compType,
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            area: this.area,
            compId: this.compId,
            storeId: this.storeId,
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },
    toDetail(path, json) {
      this.$router.push({
        path,
        query: json
      })
    },
  }
};
</script>
<style lang="less" scoped>
  .list{
    width: 7.04rem;
    margin: 0 auto;
    .inner{
      padding: 0.3rem 0;
      border-bottom: 1px solid #f5f5f5;
      .left{
        img{
          width: 0.9rem;
          height: 0.9rem;
          border-radius: 50%;
          margin-right: 0.18rem;
        }
        h5{
          font-size: 0.3rem;
          color: #010101;
          font-weight: 800;
          margin-bottom: 0.06rem;
        }
        p{
          font-size: 0.24rem;
          color: #333333;
        }
      }
      .right{
        img{
          width: 0.62rem;
          height: 0.62rem;
          margin-left: 0.56rem;
        }
        a{
          img{
            margin-left: 0;
          }
        }
      }
    }
  }
</style>